/*
  GANGSTER — required option (size) guard for every Dawn product form on the page
  (product page, featured product section, quick-add modal).

  Dawn always pre-selects the first available variant. For forms marked with data-gx-required="Beden"
  the size row starts visually unselected; add to cart and the dynamic checkout button stay blocked
  until the shopper picks a size themselves. A page opened with ?variant= (cart links, shared links)
  counts as already chosen. The variant id that is finally submitted is always Dawn's own.
*/
(function () {
  'use strict';

  var chosen = new WeakMap();
  var chosenSections = {};
  var preselected = /[?&]variant=\d+/.test(window.location.search);

  function sectionOf(form) {
    return form.dataset.sectionId || '';
  }

  function fieldsetFor(form) {
    var name = form.dataset.gxRequired;
    var scope = form.closest('product-info, .product, quick-add-modal, .featured-product') || document;
    var selects = scope.querySelector('variant-selects');
    if (!selects) return null;
    var groups = selects.querySelectorAll('fieldset, .product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var input = groups[i].querySelector('input[type="radio"], select');
      if (!input) continue;
      var optionName = input.dataset.optionName || (input.name || '').replace(/-\d+$/, '');
      if (optionName && optionName.trim().toLowerCase() === name.trim().toLowerCase()) return groups[i];
    }
    return null;
  }

  function isChosen(form) {
    var key = sectionOf(form);
    return preselected || chosen.get(form) === true || chosenSections[key] === true;
  }

  function apply(form) {
    var fieldset = fieldsetFor(form);
    if (!fieldset) {
      form.classList.remove('gx-needs-choice');
      return;
    }
    var open = !isChosen(form);
    form.classList.toggle('gx-needs-choice', open);
    fieldset.classList.toggle('gx-unpicked', open);
    if (open && !fieldset.querySelector('.gx-pick-hint')) {
      var hint = document.createElement('span');
      hint.className = 'gx-pick-hint';
      hint.textContent = form.dataset.gxHint || '';
      var legend = fieldset.querySelector('legend, label.form__label');
      if (legend && hint.textContent) legend.appendChild(hint);
    }
    if (!open) {
      var old = fieldset.querySelector('.gx-pick-hint');
      if (old) old.remove();
    }
  }

  function applyAll() {
    document.querySelectorAll('product-form[data-gx-required]').forEach(apply);
  }

  function showError(form) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var message = form.querySelector('.product-form__error-message');
    if (wrapper && message) {
      message.textContent = form.dataset.gxMessage || '';
      wrapper.hidden = false;
    }
    var fieldset = fieldsetFor(form);
    if (fieldset) {
      fieldset.classList.add('gx-shake');
      setTimeout(function () {
        fieldset.classList.remove('gx-shake');
      }, 600);
      var first = fieldset.querySelector('input:not([disabled]), select');
      fieldset.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (first) first.focus({ preventScroll: true });
    }
  }

  function clearError(form) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    if (wrapper && !wrapper.hidden) {
      var message = form.querySelector('.product-form__error-message');
      if (message && message.textContent === form.dataset.gxMessage) wrapper.hidden = true;
    }
  }

  function formFromEvent(target) {
    var host = target.closest && target.closest('product-form[data-gx-required]');
    if (host) return host;
    var form = target.closest && target.closest('form');
    if (form && form.id) return document.querySelector('product-form[data-gx-required] form#' + CSS.escape(form.id))?.closest('product-form');
    return null;
  }

  // A size pick inside the picker that belongs to a guarded form.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.closest || !input.closest('variant-selects')) return;
    var scope = input.closest('product-info, .product, quick-add-modal, .featured-product') || document;
    scope.querySelectorAll('product-form[data-gx-required]').forEach(function (form) {
      var fieldset = fieldsetFor(form);
      if (fieldset && fieldset.contains(input)) {
        chosen.set(form, true);
        chosenSections[sectionOf(form)] = true;
        clearError(form);
      }
      apply(form);
    });
  });

  // Block add to cart before Dawn's own submit handler runs.
  document.addEventListener(
    'submit',
    function (event) {
      var form = formFromEvent(event.target);
      if (!form || isChosen(form) || !fieldsetFor(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form);
    },
    true
  );

  // Block the dynamic checkout ("Hemen satın al") the same way.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.shopify-payment-button');
      if (!button) return;
      var form = button.closest('product-form[data-gx-required]');
      if (!form || isChosen(form) || !fieldsetFor(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form);
    },
    true
  );

  // Dawn re-renders the picker after every variant change and quick-add injects new forms.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      applyAll();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll);
  else applyAll();
})();
